module.exports = __webpack_public_path__ + "static/media/shell.26eafc5a.svg";